export default __webpack_public_path__ + "static/media/topaz-tag.29e34e5d.png";